/**
 * Readiness — the consolidated readiness destination (DC-1646).
 *
 * Three lenses, one destination (design: docs/design/v2.0-readiness-dashboard-consolidation.md
 * + docs/design/v3.0-maturity-matrix-ux-spec.md §1):
 * - Data Readiness — the asset axis (FAIR foundation + four dimensions +
 *   Bridge AI). Domain zoom = the Triangulation domain list rendered here;
 *   dataset zoom lives on each journey's Strategic tab; org zoom (cross-
 *   dataset rollup, DC-1625) is parked.
 * - Organizational Readiness — the execution axis (People / Governance /
 *   Interop). Org-scoped only; the Execution Risk dashboard's ONE canonical
 *   home (moved out of Settings → Governance).
 * - FAIR Maturity — the org-capability axis (DC-1613 2d, the 7×6 Pistoia
 *   FAIR-MM projection). Evidence-inferred placements, org-scoped.
 *
 * The lens bar is deliberately slim: each lens renders its own editorial
 * header (the Triangulation surface already carries the scope-eyebrow
 * pattern; the Organizational lens gained it in the DC-1646 re-skin).
 */

import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Compass, Building2, Grid3x3 } from 'lucide-react';
import './readiness.css';

export const ReadinessLayout: React.FC = () => {
  return (
    <div className="readiness-view">
      <nav className="readiness-lensbar" role="navigation" aria-label="Readiness lenses">
        <NavLink
          to="/readiness"
          end
          className={({ isActive }) => `readiness-lens ${isActive ? 'active' : ''}`}
        >
          <Compass className="lens-icon" size={15} aria-hidden="true" />
          <span>Data Readiness</span>
        </NavLink>
        <NavLink
          to="/readiness/organizational"
          className={({ isActive }) => `readiness-lens ${isActive ? 'active' : ''}`}
        >
          <Building2 className="lens-icon" size={15} aria-hidden="true" />
          <span>Organizational Readiness</span>
        </NavLink>
        <NavLink
          to="/readiness/maturity"
          className={({ isActive }) => `readiness-lens ${isActive ? 'active' : ''}`}
        >
          <Grid3x3 className="lens-icon" size={15} aria-hidden="true" />
          <span>FAIR Maturity</span>
        </NavLink>
      </nav>

      <div className="readiness-content">
        <Outlet />
      </div>
    </div>
  );
};

export default ReadinessLayout;
